import { render } from "./lookupresult_nocols.vue?vue&type=template&id=67dad7bd"
import script from "./lookupresult_nocols.vue?vue&type=script&lang=js"
export * from "./lookupresult_nocols.vue?vue&type=script&lang=js"

import "./lookupresult_nocols.vue?vue&type=style&index=0&id=67dad7bd&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__